import { zhTWDictionary as baseZhTWDictionary } from '@roll-web/constants';

export const zhTWDictionary = { ...baseZhTWDictionary };
